import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import moment from "moment";
import { CSVLink } from "react-csv";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  CircularProgress,
  Checkbox,
  TextField,
  Button,
  Grid,
  Chip,
  IconButton,
  Paper,
  Tooltip,
  Typography,
  Breadcrumbs,
} from "@material-ui/core";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { Autocomplete, Pagination } from "@material-ui/lab";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import GetAppIcon from "@material-ui/icons/GetApp";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import {
  setCurrentPage,
  setInGameTxHistorySearchTerm,
  setTxHistoryDataFilter,
  setFilterDrawerState,
  setInGamePageNumber,
  getInGameItemHistoryDataByTerm,
  getInGameItemHistoryCsvData,
  setNftTxCsvData,
  setNftTxCsvDownloader,
  getInGameItemHistoryData,
  setInGameItemTxHistoryData,
  getInGameItemOptionData,
  getInGamePmidOptionData
} from "actions";
import LocalCalendar from "components/Calendar/LocalCalendar";
import * as C from "components";
import * as V from "styles/variables";
import * as H from "helper";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      "& > *": {
        //borderBottom: 'unset',
      },
    },
    dataBtn: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(2),
      height: theme.spacing(4),
      color: V.btnLabelColor,
    },
    autoSelect: {
      marginTop: 8,
      marginLeft: 16,
    },
    gridSection: {
      marginTop: theme.spacing(1),
    },
    pageSection: {
      marginTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
    },
    table: {
      minHeight: "500px",
      overflowY: "scroll",
    },
    statsSection: {
      minHeight: 60,
      padding: theme.spacing(2),
      borderRadius: 4,
    },
    statBox: {
      marginTop: 0,
      minHeight: 60,
      paddingLeft: 8,
      borderRight: "1px solid #dcdcdc",
      "&:last-child": {
        borderRight: "none",
      },
    },
    statTitle: {
      fontSize: 13,
    },
    statValue: {
      fontSize: 15,
      paddingTop: 8,
      fontWeight: 500,
    },
    filterBtn: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(2),
      height: theme.spacing(4),
    },
    chipColorjobtribes: {
      marginTop: theme.spacing(2),
      backgroundColor: V.jobtribes,
      color: "#fff",
    },
    chipColorpuzzle: {
      marginTop: theme.spacing(2),
      backgroundColor: V.puzzle,
      color: "#fff",
    },
    chipColorluckyfarmer: {
      marginTop: theme.spacing(2),
      backgroundColor: V.luckyfarmer,
      color: "#fff",
    },
    chipColorpmportal: {
      marginTop: theme.spacing(2),
      backgroundColor: V.pmportal,
      color: "#fff",
    },
    chipColornftdep: {
      marginTop: theme.spacing(2),
      backgroundColor: V.nftdep,
      color: "#fff",
    },
    chipColorcookinburger: {
      marginTop: theme.spacing(2),
      backgroundColor: V.cookinburger,
      color: "#fff",
    },
    chipColorgraffitiracer: {
      marginTop: theme.spacing(2),
      backgroundColor: V.graffitiracer,
      color: "#fff",
    },
    chipColordragonramen: {
      marginTop: theme.spacing(2),
      backgroundColor: V.dragonramen,
      color: "#fff",
    },
    chipColorlostarchive: {
      marginTop: theme.spacing(2),
      backgroundColor: V.lostarchvie,
      color: "#193a3a",
    },
    chipColorsoulfusers: {
      marginTop: theme.spacing(2),
      backgroundColor: V.soulfusers,
      color: "#fff",
    },
    chipColorroguerollrulers: {
      marginTop: theme.spacing(2),
      backgroundColor: V.roguerollrulers,
      color: "#fff",
    },
    titleDl: {
      marginRight: 16,
      color: "#000",
    },
    breadcrumbs: {
      marginTop: -8,
      minHeight: 30,
    },
  })
);

function setChipLabel(label, classes) {
  const colorKeyName =
    "chipColor" + label.toLowerCase().replace(/[^A-Z0-9]+/gi, "");
  const newLabel = label === "NFT:DEP" ? "PlayMining NFT" : label;
  return (
    <Chip className={classes[colorKeyName]} size="small" label={newLabel} />
  );
}

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell align="left">{row.item_name}</TableCell>
        <TableCell align="left" component="th" scope="row">
          {row.content != undefined ? setChipLabel(row.content, classes) : ""}
        </TableCell>
        <TableCell align="center">{row.receipt_id}</TableCell>
        <TableCell align="right">{row.price}</TableCell>
        <TableCell align="right">{row.quantity}</TableCell>
        <TableCell align="right">{row.dep}</TableCell>
        <TableCell align="right">{row.type === "RDP" ? "Fiat" : "DEP"}</TableCell>
        <TableCell align="right">&nbsp;{row.pmid}</TableCell>
        <TableCell align="center">
          {row.country !== null &&
            row.country !== undefined &&
            row.country !== "n/a" && (
              <Tooltip
                title={H.FormatNumStrHelper.capitalize(row.country)}
                placement="right"
              >
                <img src={H.CountryHelper.getCountryCode(row.country)} />
              </Tooltip>
            )}
          {row.from_country === "n/a" && "n/a"}
          <br />
        </TableCell>
        <TableCell align="right">{row.created_at}</TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const InGameSalesTxHistory = ({
  setCurrentPage,
  currentPage,
  setInGameTxHistorySearchTerm,
  assetOption,
  txHistoryData,
  txHistoryStatData,
  txHistoryDataFilter,
  setTxHistoryDataFilter,
  pageTopLoader,
  setFilterDrawerState,
  filterDrawerState,
  itemSearchTerm,
  setInGamePageNumber,
  pageNumber,
  getInGameItemHistoryCsvData,
  setNftTxCsvData,
  itemTxCsvData,
  nftTxCsvLoader,
  getInGameItemHistoryData,
  getInGameItemHistoryDataByTerm,
  setInGameItemTxHistoryData,
  getInGameItemOptionData,
  getInGamePmidOptionData,
}) => {
  const classes = useStyles();
  const [btnStateDataFetch, setBtnState] = useState(true);
  const [assetOptions, setAssetOptions] = useState(assetOption);
  const [itemName, setItemName] = useState({ name: "" });
  const [gameLabel, setGameLabel] = useState("");
  const [targetValue, setTargetValue] = useState({ name: "" });
  const [txRowHisotryData, setTxRowHisotryData] = useState([]);
  const [noData, setNodata] = useState(false);
  const [defaultDateRange, setDefaultDateRagne] = useState([
    moment().tz("Asia/Singapore").subtract(7, "days").format("YYYY/MM/DD"),
    moment().tz("Asia/Singapore").subtract(1, "days").format("YYYY/MM/DD"),
  ]);
  const [totalPageNum, setTotalPageNum] = useState(0);
  const csvLinkRef = useRef(null);

  useEffect(() => {
    setCurrentPage(window.location.pathname);
    const game = window.location.pathname.split("/");
    getInGameItemHistoryData({page: pageNumber, target: game[2]});
    setTargetValue(game[2]);
    setNftTxCsvData([]);
    getInGameItemOptionData(game[2]);
    getInGamePmidOptionData(game[2]);
  }, []);

  useEffect(() => {
    let game = window.location.pathname.split("/");
    let target = game[2];
    if (target === "ingame-sale") {
      target = undefined;
      setGameLabel("PlayMining NFT");
    } else {
      setGameLabel(H.ContentsHelper.getContentsName(target));
    }
    getInGameItemHistoryData({page: pageNumber, target: target});
    setInGameItemTxHistoryData([]);
  }, [window.location.pathname]);

  useEffect(() => {
    if (itemTxCsvData.length > 0) {
      csvLinkRef.current.link.click();
      setNftTxCsvData([]);
    }
  }, [itemTxCsvData]);

  useEffect(() => {
    setAssetOptions(assetOption);
  }, [assetOption]);

  useEffect(() => {
    const pageCount = txHistoryStatData[0]["totalTx"] / 20;
    setTotalPageNum(Math.ceil(pageCount));
  }, [txHistoryStatData]);

  useEffect(() => {
    if (txHistoryData.length > 0) {
      let dataRows = [];
      _.each(txHistoryData, function (dataRow) {
        let rowObj = {
          item_name: dataRow[4]["stringValue"],
          receipt_id: dataRow[0]["stringValue"],
          dep: Number(dataRow[3]["stringValue"]),
          price: Number(dataRow[6]["stringValue"]),
          quantity: Number(dataRow[7]["stringValue"]),
          type: dataRow[5]["stringValue"],
          pmid: dataRow[8]["stringValue"],
          country: dataRow[9]["stringValue"],
          content: H.ContentsHelper.getContentsNameById(
            dataRow[2]["stringValue"]
          ),
          created_at: dataRow[10]["stringValue"],
        };
        dataRows.push(rowObj);
        rowObj = {};
      });
      setTxRowHisotryData(dataRows);
      setNodata(false);
    } else {
      setNodata(true);
    }
  }, [txHistoryData]);

  const handlePageChange = (event, value) => {
    setInGamePageNumber(value);
    if (itemSearchTerm.length > 0 && itemSearchTerm[0]["value"] !== "") {
      getInGameItemHistoryDataByTerm({page: value, target: targetValue});
    } else {
      getInGameItemHistoryData({page: value, target: targetValue});
    }
  };

  const setRange = (newValue) => {
    const startDate = moment(newValue[0]).format("YYYY-MM-DD");
    const endDate = moment(newValue[1]).format("YYYY-MM-DD");
    let newFilter = [...txHistoryDataFilter];
    newFilter[0]["dateRange"] = [startDate, endDate];
    setTxHistoryDataFilter(newFilter);
    setBtnState(false);
  };

  const showData = (value) => {
    if (value === "--") {
      return value;
    }
    if (isNaN(value)) {
      return 0;
    }
    return H.FormatNumStrHelper.formatCommaThousand(value);
  };

  const fetchData = () => {
    if (itemSearchTerm.length > 0 && itemSearchTerm[0]["value"] !== "") {
      getInGameItemHistoryDataByTerm({page: pageNumber, target: targetValue});
    } else {
      getInGameItemHistoryData({page: pageNumber, target: targetValue});
      const game = window.location.pathname.split("/");
      getInGameItemOptionData(game[2]);
      getInGamePmidOptionData(game[2]);
    }
    setBtnState(!btnStateDataFetch);
  };

  const handleInputChange = (data, type) => {
    switch (type) {
      case "item_name":
        setItemName({ name: data });
        break;
      default:
    }
    const termObject = {
      type: type,
      value: data.replace(/\s\s+/g, " "),
    };
    let cloneTerm = [...itemSearchTerm];

    const objIndex = cloneTerm.findIndex(
      (termObject) => termObject.type == type
    );
    if (objIndex === -1) {
      cloneTerm.push(termObject);
    } else {
      cloneTerm[objIndex].value = data;
    }
    setInGameTxHistorySearchTerm(cloneTerm);
  };

  const getMinDate = () => {
    let minDate = null;
    if (currentPage.indexOf("graffitiracer") !== -1) {
      minDate = "2022/10/31";
    }
    return minDate;
  };

  return (
    <C.ContentWrapper>
      <Grid
        container
        spacing={0}
        className={classes.gridSection}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item　xs={12}>
          <Breadcrumbs separator="›" className={classes.breadcrumbs}>
            <Typography>{gameLabel === undefined ? "PlayMining NFT" : gameLabel}</Typography>
            <Typography>InGame 売上</Typography>
            <Typography variant="subtitle1">取引詳細</Typography>
          </Breadcrumbs>
        </Grid>
        <Grid item xs={12} md={12} lg={10}>
          <Grid
            container
            spacing={1}
            className={classes.gridSection}
            alignItems="center"
            justifyContent="space-between"
          >
            <Grid item></Grid>
            <Grid item>
              <Grid container>
                <Grid item>
                  <LocalCalendar
                    setRange={setRange}
                    setBtnState={setBtnState}
                    defaultRange={defaultDateRange}
                    newRange={[
                      txHistoryDataFilter[0]["dateRange"][0],
                      txHistoryDataFilter[0]["dateRange"][1],
                    ]}
                    mDate={getMinDate()}
                  />
                </Grid>
                <Grid item>
                  <Button
                    //disabled={btnStateDataFetch}
                    className={classes.dataBtn}
                    variant="contained"
                    color="primary"
                    onClick={() => fetchData()}
                  >
                    GO
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                      //disabled={btnStateDataFetch}
                      className={classes.filterBtn}
                      variant="contained"
                      color="default"
                      onClick={() => setFilterDrawerState(!filterDrawerState ? currentPage : false )}>
                      絞込み
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={0}
        className={classes.gridSection}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12} md={12} lg={10}>
          <Paper className={classes.statsSection}>
            <Grid
              container
              direction="row"
              className={classes.gridSection}
              justifyContent="flex-start"
            >
              <Grid
                className={classes.statBox}
                item
                xs={12}
                sm={6}
                md={4}
                lg={2}
              >
                <Grid
                  container
                  direction="row"
                  className={classes.gridSection}
                  justifyContent="space-between"
                >
                  <Grid item>
                    <div className={classes.statTitle}>合計件数:</div>
                  </Grid>
                  <Grid item>
                    {nftTxCsvLoader && (
                      <CircularProgress className={classes.titleDl} size={20} />
                    )}
                    {!nftTxCsvLoader && (
                      <>
                        <IconButton
                          onClick={() => getInGameItemHistoryCsvData(targetValue)}
                          className={classes.titleDl}
                          size="small"
                        >
                          <GetAppIcon />
                        </IconButton>
                      </>
                    )}
                    <CSVLink
                      data={itemTxCsvData}
                      filename={`InGameアイテム取引詳細データ_${gameLabel}.csv`}
                      className="hidden"
                      ref={csvLinkRef}
                      target="_blank"
                    />
                  </Grid>
                </Grid>
                <div className={classes.statValue}>
                  {showData(txHistoryStatData[0]["totalTx"])}
                </div>
              </Grid>
              <Grid
                className={classes.statBox}
                item
                xs={12}
                sm={6}
                md={4}
                lg={2}
              >
                <div className={classes.statTitle}>DEP総額:</div>
                <div className={classes.statValue}>
                  {showData(txHistoryStatData[0]["totalDep"])}
                </div>
              </Grid>
              <Grid
                className={classes.statBox}
                item
                xs={12}
                sm={6}
                md={4}
                lg={2}
              >
                <div className={classes.statTitle}>Fiat件数:</div>
                <div className={classes.statValue}>
                  {showData(txHistoryStatData[0]["totalFiatTx"])}
                </div>
              </Grid>
              <Grid
                className={classes.statBox}
                item
                xs={12}
                sm={6}
                md={4}
                lg={2}
              >
                <div className={classes.statTitle}>DEP件数:</div>
                <div className={classes.statValue}>
                  {showData(txHistoryStatData[0]["totalDepTx"])}
                </div>
              </Grid>
              <Grid
                className={classes.statBox}
                item
                xs={12}
                sm={6}
                md={4}
                lg={2}
              >
                <div className={classes.statTitle}>Fiat総額:</div>
                <div className={classes.statValue}>
                  {showData(txHistoryStatData[0]["totalFiatAmount"])}
                </div>
              </Grid>
              <Grid
                className={classes.statBox}
                item
                xs={12}
                sm={6}
                md={4}
                lg={2}
              >
                <div className={classes.statTitle}>DEP総額:</div>
                <div className={classes.statValue}>
                  {showData(txHistoryStatData[0]["totalDepAmount"])}
                </div>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        className={classes.gridSection}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12} md={12} lg={10}>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table
              stickyHeader
              aria-label="collapsible table"
              className={classes.table}
            >
              <TableHead className={classes.tableHead}>
                <TableRow>
                  <TableCell align="left">アイテム</TableCell>
                  <TableCell align="left">ゲーム</TableCell>
                  <TableCell align="center">レシート ID</TableCell>
                  <TableCell align="center">単価</TableCell>
                  <TableCell align="center">個数</TableCell>
                  <TableCell align="center">合計(DEP)</TableCell>
                  <TableCell align="center">支払</TableCell>
                  <TableCell align="center">PMID</TableCell>
                  <TableCell align="center">国</TableCell>
                  <TableCell align="center">日時</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pageTopLoader && (
                  <TableRow>
                    <TableCell align="center" colSpan={9}>
                      Loading...
                    </TableCell>
                  </TableRow>
                )}
                {!noData &&
                  txRowHisotryData.map((row, index) => (
                    <Row key={index} row={row} />
                  ))}
                {!pageTopLoader && noData && (
                  <TableRow>
                    <TableCell align="center" colSpan={9}>
                      表示できるデータがありません
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>

      {totalPageNum > 0 && (
        <Grid
          container
          spacing={1}
          className={classes.pageSection}
          alignItems="center"
          justifyContent="center"
        >
          <Pagination
            count={totalPageNum}
            page={pageNumber}
            onChange={handlePageChange}
          />
        </Grid>
      )}
    </C.ContentWrapper>
  );
};

InGameSalesTxHistory.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  currentPage: state.page.currentPage,
  assetSearchLoading: state.nftDepTxHisotry.assetSearchLoading,
  assetOption: state.nftDepTxHisotry.assetOption,
  txHistoryDataFilter: state.nftDepTxHisotry.txHistoryDataFilter,
  pageTopLoader: state.page.pageTopLoader,
  filterDrawerState: state.page.filterDrawerState,
  nftTxCsvLoader: state.nftDepTxHisotry.nftTxCsvLoader,
  txHistoryData: state.inGameItemSalesHistory.txHistoryData,
  txHistoryStatData: state.inGameItemSalesHistory.txHistoryStatData,
  pageNumber: state.inGameItemSalesHistory.pageNumber,
  itemSearchTerm: state.inGameItemSalesHistory.itemSearchTerm,
  itemTxCsvData: state.inGameItemSalesHistory.itemTxCsvData,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  setTxHistoryDataFilter: (param) => dispatch(setTxHistoryDataFilter(param)),
  setFilterDrawerState: (param) => dispatch(setFilterDrawerState(param)),
  setInGamePageNumber: (param) => dispatch(setInGamePageNumber(param)),
  getInGameItemHistoryCsvData: (param) => dispatch(getInGameItemHistoryCsvData(param)),
  setNftTxCsvData: (param) => dispatch(setNftTxCsvData(param)),
  setNftTxCsvDownloader: (param) => dispatch(setNftTxCsvDownloader(param)),
  getInGameItemHistoryData: (param) => dispatch(getInGameItemHistoryData(param)),
  setInGameItemTxHistoryData: (param) => dispatch(setInGameItemTxHistoryData(param)),
  getInGameItemHistoryDataByTerm: (param) => dispatch(getInGameItemHistoryDataByTerm(param)),
  setInGameTxHistorySearchTerm: (param) => dispatch(setInGameTxHistorySearchTerm(param)),
  getInGameItemOptionData: (param) => dispatch(getInGameItemOptionData(param)),
  getInGamePmidOptionData: (param) => dispatch(getInGamePmidOptionData(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(InGameSalesTxHistory));
